import React, { useRef, useState } from "react";
import { useStyles } from "./SearchModal.styles";
import { IconButton, Link, SearchBox, Toggle } from "@fluentui/react";
import { IdGroup, SearchItemList } from "@v2/components/controls/PickerList/search/SearchItemList/SearchItemList";
import { useScrollClip } from "@v2/components/controls/PickerList/search/hooks";

interface SearchModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  items: any[];
  selectedIds: string[];
  onSelectionChange: (itemId: string[]) => void;
  idGroups?: IdGroup[];
}

export const SearchModal: React.FC<SearchModalProps> = (props) => {
  const {items, selectedIds, idGroups, onSelectionChange} = props;
  const [searchValue, setSearchValue] = useState('')
  const [showOnlySelected, setShowOnlySelected] = useState(false);
  const searchBoxRef = useRef<HTMLDivElement>(null);

  const {isOpen, onDismiss} = props;
  const classes = useStyles();

  const handleItemSelected = (itemId: string, selected: boolean) => {
    const newSelection = [...selectedIds];
    if (selected) {
      newSelection.push(itemId);
    } else {
      const idIndex = selectedIds.indexOf(itemId);
      idIndex > -1 && newSelection.splice(idIndex, 1);
    }
    onSelectionChange(newSelection);
  }

  const handleSelectAll = () => {
    onSelectionChange(items.map(item => item.id))
  }

  const handleClearAll = () => {
    onSelectionChange([]);
  }

  const contentRef = useRef<HTMLDivElement>(null);

  useScrollClip(isOpen);

  if (!isOpen) {
    return null;
  }

  return (
    <div className={classes.backdrop} onClick={() => onDismiss()}>
      <div
        className={classes.modalDialog}
        onClick={(event) => event.stopPropagation()}
        ref={contentRef}
      >
        <div className={classes.header}>
          <IconButton iconProps={{iconName: 'Cancel'}} onClick={() => onDismiss()}/>
        </div>
        <SearchBox
          iconProps={{iconName: 'search'}}
          ref={searchBoxRef}
          value={searchValue}
          onChange={(_, newValue) => setSearchValue(newValue || '')}
          placeholder={'Type name to search'}
          styles={{
            root: {flexShrink: 0, margin: '0 12px'}
          }}
        />
        <div className={classes.topPanel}>
          <Toggle
            checked={showOnlySelected}
            onChange={(_, checked) => setShowOnlySelected(!!checked)}
          />
          <span className={classes.controlLabel}>show only selected</span>
        </div>
        <SearchItemList
          items={items}
          selectedIds={selectedIds}
          showOnlySelected={showOnlySelected}
          onItemSelected={handleItemSelected}
          searchValue={searchValue}
          idGroups={idGroups}
        />
        <div className={classes.bottomPanel}>
          <Link onClick={handleSelectAll}>
            Select all
          </Link>
          <Link onClick={handleClearAll}>
            Clear all
          </Link>
        </div>
      </div>
    </div>
  )
}
